// extracted by mini-css-extract-plugin
module.exports = {"elipsisMobile":"styles_elipsisMobile__286OZ"};